export const ajax=(url)=>{
    return fetch(url).then(data => data.json());
}


// WEBPACK FOOTER //
// ./src/Utils/index.js